import {IOption} from "@pg-design/select-module";

export enum SortType {
    INSTALMENT_RATE = 1,
    RRSO_UP = 2,
    RRSO_DOWN = 3,
    PERCENT_UP = 4,
    PERCENT_DOWN = 5,
    COMMISSION_UP = 6,
    COMMISSION_DOWN = 7,
    COSTS = 8
}

export const CreditOffersSortOptions: IOption[] = [
    {
        label: "Rata: od najtańszej",
        value: SortType.INSTALMENT_RATE
    },
    {
        label: "RRSO: rosnąco",
        value: SortType.RRSO_UP
    },
    {
        label: "RRSO: malejąco",
        value: SortType.RRSO_DOWN
    },
    {
        label: "Prowizja: rosnąco",
        value: SortType.COMMISSION_UP
    },
    {
        label: "Prowizja: malejąco",
        value: SortType.COMMISSION_DOWN
    },
    {
        label: "Oprocentowanie: rosnąco",
        value: SortType.PERCENT_UP
    },
    {
        label: "Oprocentowanie: malejąco",
        value: SortType.PERCENT_DOWN
    },
    {
        label: "Koszt kredytu: rosnąco",
        value: SortType.COSTS
    }
];
import {IOption} from "@pg-design/select-module";

export enum SortType {
    INSTALMENT_RATE = 1,
    RRSO_UP = 2,
    RRSO_DOWN = 3,
    PERCENT_UP = 4,
    PERCENT_DOWN = 5,
    COMMISSION_UP = 6,
    COMMISSION_DOWN = 7,
    COSTS = 8
}

export const CreditOffersSortOptions: IOption[] = [
    {
        label: "Rata: od najtańszej",
        value: SortType.INSTALMENT_RATE
    },
    {
        label: "RRSO: rosnąco",
        value: SortType.RRSO_UP
    },
    {
        label: "RRSO: malejąco",
        value: SortType.RRSO_DOWN
    },
    {
        label: "Prowizja: rosnąco",
        value: SortType.COMMISSION_UP
    },
    {
        label: "Prowizja: malejąco",
        value: SortType.COMMISSION_DOWN
    },
    {
        label: "Oprocentowanie: rosnąco",
        value: SortType.PERCENT_UP
    },
    {
        label: "Oprocentowanie: malejąco",
        value: SortType.PERCENT_DOWN
    },
    {
        label: "Koszt kredytu: rosnąco",
        value: SortType.COSTS
    }
];
